// @ts-nocheck
/*
 * Port of views/dashboard/ivr/voice-library/view-voice.js (8 lines).
 * BYTE-IDENTICAL — v1 is an empty stub component.
 *
 * V1 QUIRK preserved: this file was never fleshed out; the route just
 * mounts a "ViewVoice" text div. Kept verbatim to match the source of
 * truth. Real voice-library viewing lives at ViewVoiceFilesPage under
 * the top-level voice-library feature dir.
 */
import React from 'react';

const ViewVoice = () => {
  return <div>ViewVoice</div>;
};

export default ViewVoice;
